module.exports = __webpack_public_path__ + "static/fonts/Mont-BoldItalic.ee01465.woff2";